import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import AuthProvider from "./components/Context/AuthContext";
import Footer from "./components/Footer/Footer";
import Menu from "./components/Menu/Menu";
import NotFound from "./components/NotFound/NotFound";
import Services from "./components/Services/Services";
import ServicesDetails from "./components/Services/ServicesDetails";
import PopupButton from "./components/PopupButton/PopupButton";
import CookieConsentPopup from "./components/CookieConsentPopup/CookieConsentPopup";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";
import Disclaimer from "./components/Legal/Disclaimer";
import Impressum from "./components/Legal/Impressum";
import Credits from "./components/Legal/Credits";


function App() {
  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();

    const disableImageDragClick = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableContextMenu);
    document.addEventListener("dragstart", disableImageDragClick);
    document.addEventListener("click", disableImageDragClick);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("dragstart", disableImageDragClick);
      document.removeEventListener("click", disableImageDragClick);
    };
  }, []);

  return (
    <div>
      <Router>
        <AuthProvider>
          <PopupButton />
          <Routes>
            <Route
              exact
              path="/"
              element={
                <>
                  <Home />
                </>
              }
            />
            <Route
              exact
              path="/home"
              element={
                <>
                  <Home />
                </>
              }
            />
            <Route
              path="/about"
              element={
                <>
                  <Menu />
                  <About />
                </>
              }
            />
            <Route
              path="/services"
              element={
                <>
                  <Menu />
                  <Services /> 
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <Menu />
                  <Contact />
                </>
              }
            />

            <Route
              path="/services/:serviceId"
              element={
                <>
                  <Menu />
                  <ServicesDetails /> 
                </>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <>
                  <Menu />
                  <PrivacyPolicy />
                </>
              }
            />
            <Route
              path="/disclaimer"
              element={
                <>
                  <Menu />
                  <Disclaimer />
                </>
              }
            />
            <Route
              path="/credits"
              element={
                <>
                  <Menu />
                  <Credits />
                </>
              }
            />
            <Route
              path="/impressum"
              element={
                <>
                  <Menu />
                  <Impressum />
                </>
              }
            />
            <Route
              path="*"
              element={
                <>
                  <Menu />
                  <NotFound />
                </>
              }
            />
          </Routes>
           <Footer />
           <CookieConsentPopup /> 
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;